import { TeaContainer } from "./container";
import { MixTea } from "./instance/mix-sdk";
const Tea = new TeaContainer();
Tea._inject(new MixTea());
export {
  Tea
};

//# sourceMappingURL=singleton.js.map